import { PARAGRAPH_EXTRA_SPACING_ATTRIBUTE as e } from "./constants.mjs";
import { getParagraphStyles as t } from "./utils.mjs";
import { NodeViewContent as n } from "@tiptap/react";
import { jsx as r } from "react/jsx-runtime";
//#region src/extensions/paragraph-extension/custom-paragraph-node-view.tsx
var i = ({ node: i }) => {
	let { textAlign: a, indent: o, lineHeight: s } = i.attrs, c = i.attrs[e];
	return /* @__PURE__ */ r("p", {
		"data-node-view-wrapper": "",
		style: {
			...t(c),
			textAlign: a,
			marginLeft: `${o}px`,
			...s && { lineHeight: s }
		},
		dir: "auto",
		children: /* @__PURE__ */ r(n, { as: "span" })
	});
};
//#endregion
export { i as CustomParagraphNodeView };
